class PipingRadiosEmbroidery extends PipingRadios {
  constructor() {
    super();
    this.optionLegend = this.querySelector('.product-form__input-piping')?.querySelector('aside').querySelector('span');
    this.embroideryOptions = this.closest('embroidery-options');
    this.preventScroll = true;
  }

  onRadioChange() {
    this.getSelectedRadio();
    this.getSelectedSize();
    this.setParentTrimRadio();
    this.setPipingRadio();
    this.updateOptionLegend();
    this.updateMedia();
    this.updateEmbroideryMedia();
    document.querySelector('piping-radios').onRadioChange();
  }

  updateOptionLegend() {
    if (!this.optionLegend || !this.piping) return;
    this.optionLegend.innerText = this.piping.handle;
  }

  updateEmbroideryMedia() {
    if (!this.embroideryOptions) return;
    this.embroideryOptions.setPillowImage();
    this.embroideryOptions.scrollModalToTop();
  }

  setParentTrimRadio() {
    if (!this.piping) return;
    document.querySelector(`input[name="properties[Trim]"][value="${this.piping.handle}"]`).checked = true;
    document.querySelector('piping-radios').dispatchEvent(new Event('change', { bubbles: true }))
  }
}

customElements.define('piping-radios-embroidery', PipingRadiosEmbroidery);
